import { render, staticRenderFns } from "./yoy.vue?vue&type=template&id=1684149e&scoped=true&"
import script from "./yoy.vue?vue&type=script&lang=ts&"
export * from "./yoy.vue?vue&type=script&lang=ts&"
import style0 from "./yoy.vue?vue&type=style&index=0&id=1684149e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684149e",
  null
  
)

export default component.exports